module.exports = __webpack_public_path__ + "statics/img/6.f893699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/6.png
// module id = UcJ0
// module chunks = 1